import { deprecationLog } from '../../../../../common/deprecationLog';
const buttonTypes = ['submit', 'reset', 'button'];
const invalidAnchorType = (type) => buttonTypes.findIndex((t) => t === type) >= 0;
export const validateComponentType = (tagName, type) => {
    if (tagName === 'a' && invalidAnchorType(type)) {
        deprecationLog('Button', "Anchor element must not have 'submit', 'reset' or 'button' type");
        return;
    }
};
//# sourceMappingURL=helpers.js.map